import { baseClient } from "./baseRequest";

export enum AlertAction {
  Message = "message",
  Assign = "assign",
}

export interface AlertUser {
  id: string;
  actions: AlertAction[];
}

export interface AlertPolicy {
  id: string;
  name: string;
  adminUsers: AlertUser[];
  // At most one policy carries this flag; it is attached to clock-internal
  // monitors auto-created by failure reports.
  defaultForClockMonitors?: boolean;
  // Number of monitors referencing this policy (returned by the list endpoint).
  monitorCount?: number;
}

export interface AlertPolicyAdmin {
  id: string;
  name: string;
  phoneNumber: string;
}

export interface AlertPoliciesClient {
  list: () => Promise<AlertPolicy[]>;
  get: (id: string) => Promise<AlertPolicy>;
  create: (data: Partial<AlertPolicy>) => Promise<AlertPolicy>;
  update: (id: string, data: Partial<AlertPolicy>) => Promise<AlertPolicy>;
  remove: (id: string) => Promise<void>;
  listAdminUsers: () => Promise<AlertPolicyAdmin[]>;
  // Sets the phone an admin receives alerts on; null removes it.
  setAdminPhone: (userId: string, phoneNumber: string | null) => Promise<void>;
}

const alertPoliciesClient: AlertPoliciesClient = {
  list: () => baseClient.get<AlertPolicy[]>({ url: "/admin/alert-policies" }),
  listAdminUsers: () =>
    baseClient.get<AlertPolicyAdmin[]>({
      url: "/admin/alert-policies/admin-users",
    }),
  setAdminPhone: (userId, phoneNumber) =>
    baseClient.put<void>({
      url: `/admin/alert-policies/admin-users/${userId}/phone`,
      body: { phoneNumber },
    }),
  get: (id) =>
    baseClient.get<AlertPolicy>({ url: `/admin/alert-policies/${id}` }),
  create: (data) =>
    baseClient.post<AlertPolicy>({ url: "/admin/alert-policies", body: data }),
  update: (id, data) =>
    baseClient.put<AlertPolicy>({
      url: `/admin/alert-policies/${id}`,
      body: data,
    }),
  remove: (id) =>
    baseClient.delete<void>({ url: `/admin/alert-policies/${id}` }),
};

export default alertPoliciesClient;
